import { z } from 'zod'

const marketingSourceEnum = z
  .enum(['SEO', 'SEM', 'SOCIAL', 'MAILING', 'DIRECT', 'REFERER'])
  .nullable()
const landingPageGroupEnum = z
  .enum(['0', '1', '2', '3', '4', '5', '6', '7'])
  .nullable()

export const travelerContactParams = z.object({
  name: z.string(),
  email: z.string(),
  phone: z.string(),
  allowComms: z.boolean(),
})

const dataMiningSchema = z.object({
  platform: z.enum(['web_mobile', 'web_desktop']).nullable(),
  marketingSource: marketingSourceEnum,
  campaignUTM: z.string().nullable(),
  landingPageGroup: landingPageGroupEnum,
})

export const paramsSchema = z.object({
  source: z.enum(['ESCAPADA_RURAL', 'WIDGET', 'WEBSITE']),
  cottageId: z.string(),
  traveler: travelerContactParams,
  message: z.string(),
  kpisData: dataMiningSchema.optional(),
  channel: z.enum(['EMAIL', 'WHATSAPP']),
})

export type landingPageGroup = z.infer<typeof landingPageGroupEnum>
export type marketingSource = z.infer<typeof marketingSourceEnum>
export type DataMining = z.infer<typeof dataMiningSchema>
export type paramsType = z.infer<typeof paramsSchema>
